import React from 'react';
import { DEFAULT_GAS_CHANNEL } from '../events';
import { AnalyticsListener } from '@atlaskit/analytics-next';
export const SearchDialogAnalyticsContext = ({
  analyticContext,
  nonPrivacySafeAnalyticContext = {},
  filterAnalyticsContext = {},
  nonPrivacySafeAnalyticContextGenerator,
  children
}) => {
  return /*#__PURE__*/React.createElement(AnalyticsListener, {
    channel: DEFAULT_GAS_CHANNEL,
    onEvent: event => {
      const additionalAttributes = typeof analyticContext === 'function' ? analyticContext() : analyticContext;
      const nonPrivacySafeAttributes = nonPrivacySafeAnalyticContextGenerator !== undefined ? nonPrivacySafeAnalyticContextGenerator() : nonPrivacySafeAnalyticContext;
      event.update(payload => {
        var _payload$attributes;
        const filters = {
          ...((_payload$attributes = payload.attributes) === null || _payload$attributes === void 0 ? void 0 : _payload$attributes.filters),
          ...filterAnalyticsContext
        };
        // Operational event not support nonPrivacySafeAttributes
        const nonPrivacySafeAttributesPayload = payload.eventType === 'operational' ? {} : {
          nonPrivacySafeAttributes: {
            ...(payload === null || payload === void 0 ? void 0 : payload.nonPrivacySafeAttributes),
            ...nonPrivacySafeAttributes
          }
        };
        return {
          ...payload,
          attributes: {
            ...payload.attributes,
            ...additionalAttributes,
            filters: Object.keys(filters).length > 0 ? filters : undefined
          },
          ...nonPrivacySafeAttributesPayload
        };
      });
    }
  }, children);
};